import React, { useEffect, useState } from "react";
import { fetchSoundsDatabase } from "../../services/nocodb";
import sortByDate from "./../../helpers/sortByDate";

import ListItem from "./ListItem";

const CACHE_KEY = "cachedSounds";
const CACHE_EXPIRY_MS = 1000 * 60 * 60; // 1 hour

function List() {
  const [sounds, setSounds] = useState();
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSounds();
  }, [reload]);

  async function getSounds() {
    const cached = localStorage.getItem(CACHE_KEY);
    const cachedTime = localStorage.getItem(`${CACHE_KEY}_timestamp`);
    const now = Date.now();
    const isCacheValid = cached && cachedTime && now - cachedTime < CACHE_EXPIRY_MS;

    if (isCacheValid) {
      try {
        const cachedData = JSON.parse(cached);
        sortByDate(cachedData);
        setSounds(cachedData);
        setLoading(false);
        return;
      } catch (e) {
        console.warn("Corrupted sound cache, refetching...");
      }
    }

    try {
      const data = await fetchSoundsDatabase();
      sortByDate(data);
      setSounds(data);
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      localStorage.setItem(`${CACHE_KEY}_timestamp`, now.toString());
    } catch (err) {
      console.error("Error loading sounds from NocoDB", err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div className={"loader"}></div>;

  return (
    <div className="row">
      {
        sounds &&
        sounds.map(sound => 
          <ListItem
            key={sound.Id}
            sound={sound}
            setReload={setReload}
          />
        )
      }
    </div>
  );
}

export default List;